import React, { useState, useEffect } from 'react';

import useAuth from '~/hooks/useAuth';

import dabangBridge from '~/utils/bridge';
import apiCall, { LIVE_URL, TEST_URL } from '~/utils/apiCall';

import BG from '~/components/background';

import top from './images/top.png';

import goSign from './images/go-sign.png';

import quiz from './images/quiz.png';
import question from './images/question.png';
import q1 from './images/q1.png';
import q2 from './images/q2.png';
import q3 from './images/q3.png';
import q4 from './images/q4.png';
import q5 from './images/q5.png';
import q1C from './images/q1-checked.png';
import q2C from './images/q2-checked.png';
import q3C from './images/q3-checked.png';
import q4C from './images/q4-checked.png';
import q5C from './images/q5-checked.png';
import submitBtn from './images/submit-btn.png';

import popup from './images/popup.png';

import bottom from './images/bottom.png';

import { Wrap, GoSignWrap, AgreeWrap, Label, Checkbox, Ul, QuizWrap } from './styled';

function Arrow() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path fill="#F2F2F2" d="M0 0H40V40H0z" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000)"/>
              <path stroke="#434343" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M27 9L27 23 13 23" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000) translate(20.000000, 16.000000) rotate(-315.000000) translate(-20.000000, -16.000000)"/>
          </g>
          </g>
        </g>
      </g>
  </svg>
  );
}

const SIGN_URL = 'https://sign.dabangapp.com';

function MainComponent() {
  const [agree1, setAgree1] = useState(false);
  const [isSending, setSending] = useState(false);
  const [isSubmit, setSubmit] = useState(false);
  const [answer, setQuestion] = useState(null);

  const { authKey } = useAuth();

  useEffect(() => {
    if (isSubmit) {
      document.body.style.height = '100%';
      document.body.style.minHeight = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';

    } else {
      document.body.style.height = '';
      document.body.style.minHeight = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }
  }, [isSubmit])

  const agreeText1 = [
    '1. 개인정보 수집 및 이용 목적 : 당첨자 선정',
    '2. 수집하려는 개인정보의 항목 : 이름, 휴대폰 번호',
    '3. 개인정보의 보유 및 이용 기간 : 당첨자 선정 후 3개월간 보관 후 파기',
    '4. 본 개인정보 제공에 동의를 거부할 권리가 있으며, 동의 거부 시 이벤트 참여가 제한됨',
    '5. 제공해 주신 개인 정보는 이벤트 경품 발송 용도 이외는 활용하지 않습니다',
  ];

  function close() {
    dabangBridge.android(call => {
      call.finishActivity();
    });

    dabangBridge.ios(call => {
      call.callHandler('iOS Echo', {
        cmd: 'finishActivity',
      });
    });
  }

  function clickGoSignHome() {
    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openInAppBrowser',
        url: SIGN_URL,
      });
    });

    dabangBridge.android(call => {
      console.log('android');
      call.openInAppBrowser(SIGN_URL);
    });
  }

  const clickQustion = val => {
    if (answer === val) return;
    setQuestion(val);
  }

  async function submit() {
    if (!agree1) return alert('본 이벤트는 개인정보 수집/이용 항목에 동의 후 참여가능 합니다.');
    if (!answer) return alert('정답을 선택 해주세요.');
    if (isSending) return;

    setSending(true);

    try {
      // answer 1, 2, 3, 4, 5
      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/2021/12/quiz`, { authKey, answer });
      const errorCode = [501, 502, 503, 504, 505, 506, 507, 508];

      setSending(false);

      if (!res) {
        alert('본 이벤트는 조기 마감되었습니다. 감사합니다.');
        close();

      } else {
        if (errorCode.includes(res.code)) {
          alert(res.msg);

          if (res.code === 501) {                   // 로그인 안되어 있는 경우 로그인 페이지로 이동하는 브릿지
            dabangBridge.ios(call => {
              call.callHandler('ObjC Echo', {
                cmd: 'showLoginAndReload',
              });
            });
        
            dabangBridge.android(call => {
              console.log('android');
              call.showLoginAndReload();
            });
            
          } else if (res.code === 502 || res.code === 508) {            // 본인인증 페이지로 이동
            dabangBridge.ios(call => {
              call.callHandler('ObjC Echo', {
                cmd: 'showAuthAndReload',
              });
            });
        
            dabangBridge.android(call => {
              console.log('android');
              call.showAuthAndReload();
            });
          }

        } else if (res.code === 200) {
          setSubmit(true);
          alert('이벤트 참여 완료하였습니다.');
        }
      }

    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
      setSending(false);
    }
  }

  return (
    <Wrap isSubmit={isSubmit}>
      <BG width={710} height={2359} imgUrl={top} />
      <AgreeWrap>
        <Label isCheck={agree1}>
          <Checkbox type="checkbox" checked={agree1} onChange={() => setAgree1(prev => !prev)} />
          <p>개인정보 수집/이용에 대한 동의</p>
          <Arrow />
        </Label>
  
        {agree1 && (
          <Ul>
            {agreeText1.map((text, key) => (
              <li key={key}>{text}</li>
            ))}
          </Ul>
        )}
      </AgreeWrap>

      <GoSignWrap>
        <BG width={710} height={229} imgUrl={goSign} />
          <button className="submit" onClick={clickGoSignHome} />
      </GoSignWrap>

      <QuizWrap>
        <BG width={710} height={934} imgUrl={quiz} />
        <img className="question" src={question} alt="question" />

        <div className="answer">
          <img className="q1" src={answer && answer === '1' ? q1C : q1} alt="" onClick={() => clickQustion('1')} />
          <img className="q2" src={answer && answer === '2' ? q2C : q2} alt="" onClick={() => clickQustion('2')} />
          <img className="q3" src={answer && answer === '3' ? q3C : q3} alt="" onClick={() => clickQustion('3')} />
          <img className="q4" src={answer && answer === '4' ? q4C : q4} alt="" onClick={() => clickQustion('4')} />
          <img className="q5" src={answer && answer === '5' ? q5C : q5} alt="" onClick={() => clickQustion('5')} />
        </div>

        <img className="submit" src={submitBtn} alt="" onClick={submit} />
      </QuizWrap>

      <BG width={710} height={613} imgUrl={bottom} />

      {isSubmit && (
        <div className="overlay">
          <img className="popup" src={popup} alt="popup" onClick={close} />
        </div>
      )}
    </Wrap>
  );
}

export default MainComponent;
